/*
  Formulare des Installateursportals: Anmeldung eines Fachbetriebs und Anfrage
  eines Kunden. Beide schicken an eine Edge Function in Supabase, nie direkt in
  die Datenbank (Bauplan 5).

  Am Formular steht, welche Funktion gemeint ist:
    data-inst-formular="betrieb-anmelden" | "anfrage-senden"
  Adresse und oeffentlicher Schluessel kommen wie bei der Suche aus den
  Theme-Einstellungen.

  Die Felder heissen genau so, wie die Funktion sie erwartet. Mehrfachauswahl
  (Gewerke) wird zur Liste, einzelne Haken werden true, Zahlenfelder zu Zahlen.
  Das Feld "fax" ist die Spamfalle: fuer Menschen unsichtbar, Bots fuellen es.
*/
(function () {
  'use strict';

  var MELDUNGEN = {
    firma: 'Bitte den Firmennamen angeben.',
    name: 'Bitte deinen Namen angeben.',
    email: 'Bitte die E-Mail-Adresse prüfen.',
    plz: 'Bitte eine fünfstellige Postleitzahl angeben.',
    plz_unbekannt: 'Diese Postleitzahl kennen wir nicht. Bitte noch einmal prüfen.',
    ort: 'Bitte den Ort angeben.',
    datenschutz: 'Ohne die Zustimmung zur Datenverarbeitung können wir die Anmeldung nicht annehmen.',
    zustimmung: 'Ohne deine Zustimmung dürfen wir die Anfrage nicht weitergeben.',
    zu_viele: 'Das waren gerade viele Anfragen von deinem Anschluss. Bitte versuch es in einer Stunde noch einmal.',
    herkunft: 'Das hat technisch nicht geklappt. Bitte lade die Seite neu.',
    json: 'Das hat technisch nicht geklappt. Bitte versuch es noch einmal.',
    logo_gross: 'Das Logo ist zu groß. Bitte ein kleineres Bild wählen.',
    logo_typ: 'Das Logo muss ein PNG-, JPG- oder WebP-Bild sein.',
    partnerbedingungen: 'Bitte die Partnerbedingungen akzeptieren, sonst können wir die Anmeldung nicht annehmen.',
    text: 'Bitte beschreib kurz, was passiert ist (mindestens ein Satz).',
    betrieb: 'Der Betrieb wurde nicht gefunden. Bitte lade die Seite neu.',
    login: 'Bitte zuerst mit deinem Kundenkonto einloggen und die Seite neu laden.',
    schon_mitglied: 'Dein Kundenkonto gehört schon zu einem Betrieb. Für einen weiteren Betrieb brauchst du ein eigenes Konto.',
    email_vorhanden: 'Mit dieser Mailadresse ist schon ein Betrieb angemeldet. Schreib uns an admin@solaroutlet.de, wenn das euer Betrieb ist.',
    server: 'Bei uns ist etwas schiefgegangen. Bitte versuch es gleich noch einmal oder schreib an info@solaroutlet.de.'
  };

  function wert(feld) {
    if (feld.type === 'checkbox') return feld.checked;
    if (feld.type === 'number') return feld.value === '' ? null : Number(feld.value);
    return feld.value;
  }

  function daten(form) {
    var raus = {};
    var felder = form.querySelectorAll('input[name], textarea[name], select[name]');
    for (var i = 0; i < felder.length; i++) {
      var f = felder[i];
      var name = f.getAttribute('name');
      if (f.type === 'file') continue;
      if (f.tagName === 'SELECT' && f.hasAttribute('data-inst-liste')) {
        // Einzelauswahl, die die Funktion als Liste erwartet (Kasten auf der Betriebsseite)
        if (!Array.isArray(raus[name])) raus[name] = [];
        if (f.value) raus[name].push(f.value);
      } else if (f.type === 'checkbox' && f.hasAttribute('data-inst-liste')) {
        // Mehrfachauswahl, zum Beispiel die Gewerke
        if (!Array.isArray(raus[name])) raus[name] = [];
        if (f.checked) raus[name].push(f.value);
      } else {
        raus[name] = wert(f);
      }
    }
    return raus;
  }

  function InstallateurFormular(form) {
    this.form = form;
    this.funktion = form.getAttribute('data-inst-formular');
    this.url = (form.getAttribute('data-supabase-url') || '').replace(/\/+$/, '');
    this.schluessel = form.getAttribute('data-supabase-key') || '';
    this.fehler = form.querySelector('[data-inst-formular-fehler]');
    this.knopf = form.querySelector('button[type="submit"]');
    var huelle = form.closest('[data-inst-formular-huelle]') || form.parentNode;
    this.danke = huelle.querySelector('[data-inst-formular-danke]');
    this.dankeNummer = huelle.querySelector('[data-inst-formular-nummer]');
    this.dankeBetrieb = huelle.querySelector('[data-inst-formular-betrieb]');

    this.logo = null;
    this.logoEinrichten();
    this.schritteEinrichten();
    this.vorschlagEinrichten();

    var ich = this;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      // Enter in einem Schritt heisst "Weiter", abgeschickt wird erst im letzten
      if (ich.schritte && ich.aktuell < ich.schritte.length - 1) {
        var vor = ich.schritte[ich.aktuell].querySelector('[data-inst-vorschlag]');
        if (vor) vor.click(); else ich.weiter();
        return;
      }
      ich.abschicken();
    });
  }

  /*
    Ablauf in Schritten (Anmeldung, Wunsch Michel 21.09.2026): je Schritt ein
    fieldset mit data-inst-schritt. "Weiter" prueft nur die Felder des Schritts.
  */
  InstallateurFormular.prototype.schritteEinrichten = function () {
    var ich = this;
    var liste = [].slice.call(this.form.querySelectorAll('[data-inst-schritt]'));
    if (!liste.length) return;
    this.schritte = liste;
    this.aktuell = 0;
    this.anzeige = this.form.querySelector('[data-inst-schritt-anzeige]');
    this.balken = this.form.querySelector('[data-inst-schritt-balken]');
    this.form.querySelectorAll('[data-inst-weiter]').forEach(function (b) {
      b.addEventListener('click', function () { ich.weiter(); });
    });
    this.form.querySelectorAll('[data-inst-zurueck]').forEach(function (b) {
      b.addEventListener('click', function () { ich.zeige(ich.aktuell - 1); });
    });
    // Enter in einem Feld: der Absende-Knopf steckt im versteckten letzten Schritt,
    // deshalb loest der Browser selbst nichts aus. Wir behandeln Enter wie "Weiter".
    this.form.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' || e.target.tagName === 'TEXTAREA' || e.target.tagName === 'BUTTON' || e.target.type === 'checkbox') return;
      if (ich.aktuell >= ich.schritte.length - 1) return;
      e.preventDefault();
      var vor = ich.schritte[ich.aktuell].querySelector('[data-inst-vorschlag]');
      var kasten = ich.schritte[ich.aktuell].querySelector('[data-inst-vorschlaege]');
      if (vor && (!kasten || kasten.hidden)) vor.click(); else if (!vor) ich.weiter();
    });
    this.zeige(0, true);
  };

  InstallateurFormular.prototype.schrittGueltig = function () {
    var felder = this.schritte[this.aktuell].querySelectorAll('input, select, textarea');
    for (var i = 0; i < felder.length; i++) {
      if (felder[i].type === 'hidden' || felder[i].type === 'file') continue;
      if (!felder[i].checkValidity()) { felder[i].reportValidity(); return false; }
    }
    return true;
  };

  InstallateurFormular.prototype.weiter = function () {
    if (this.schrittGueltig()) this.zeige(this.aktuell + 1);
  };

  InstallateurFormular.prototype.zeige = function (i, ohneRollen) {
    if (!this.schritte) return;
    i = Math.max(0, Math.min(this.schritte.length - 1, i));
    this.aktuell = i;
    this.schritte.forEach(function (s, k) { s.hidden = k !== i; });
    var n = this.schritte.length;
    if (this.anzeige) this.anzeige.textContent = 'Schritt ' + (i + 1) + ' von ' + n + ' · ' + (this.schritte[i].getAttribute('data-titel') || '');
    if (this.balken) this.balken.style.width = Math.round(((i + 1) / n) * 100) + '%';
    this.melden('');
    if (ohneRollen) return;
    var huelle = this.form.closest('[data-inst-formular-huelle]') || this.form;
    var oben = huelle.getBoundingClientRect().top;
    // Unter die feste Kopfzeile rollen, nicht dahinter
    var kopf = document.querySelector('.header-section, header');
    var abstand = (kopf ? kopf.getBoundingClientRect().height : 0) + 20;
    if (oben < abstand || oben > window.innerHeight * 0.6) window.scrollTo({ top: oben + window.scrollY - abstand, behavior: 'smooth' });
    var erstes = this.schritte[i].querySelector('input:not([type=hidden]):not([type=checkbox]):not([type=file]), select, textarea');
    if (erstes) { try { erstes.focus({ preventScroll: true }); } catch (x) { erstes.focus(); } }
  };

  /*
    Logo: im Browser auf hoechstens 600 px verkleinern und als WebP (sonst PNG)
    neu speichern. Das macht auch grosse Fotos klein genug und wirft
    eingebettete Metadaten weg. Die Funktion prueft den Typ danach noch einmal.
  */
  InstallateurFormular.prototype.logoEinrichten = function () {
    var ich = this;
    var feld = this.form.querySelector('[data-inst-logo]');
    if (!feld) return;
    var vorschau = this.form.querySelector('[data-inst-logo-vorschau]');
    var leer = this.form.querySelector('[data-inst-logo-leer]');
    var name = this.form.querySelector('[data-inst-logo-name]');
    var weg = this.form.querySelector('[data-inst-logo-weg]');
    var nameStart = name ? name.textContent : '';

    function zuruecksetzen() {
      ich.logo = null;
      feld.value = '';
      if (vorschau) { vorschau.hidden = true; vorschau.removeAttribute('src'); }
      if (leer) leer.hidden = false;
      if (name) name.textContent = nameStart;
      if (weg) weg.hidden = true;
    }

    feld.addEventListener('change', function () {
      var datei = feld.files && feld.files[0];
      if (!datei) { zuruecksetzen(); return; }
      if (['image/png', 'image/jpeg', 'image/webp'].indexOf(datei.type) === -1) { zuruecksetzen(); ich.melden(MELDUNGEN.logo_typ); return; }
      if (datei.size > 15 * 1024 * 1024) { zuruecksetzen(); ich.melden(MELDUNGEN.logo_gross); return; }
      ich.melden('');
      var adresse = URL.createObjectURL(datei);
      var bild = new Image();
      bild.onload = function () {
        var max = 600;
        var faktor = Math.min(1, max / Math.max(bild.naturalWidth, bild.naturalHeight));
        var c = document.createElement('canvas');
        c.width = Math.max(1, Math.round(bild.naturalWidth * faktor));
        c.height = Math.max(1, Math.round(bild.naturalHeight * faktor));
        c.getContext('2d').drawImage(bild, 0, 0, c.width, c.height);
        URL.revokeObjectURL(adresse);
        var url = c.toDataURL('image/webp', 0.9);
        if (url.indexOf('data:image/webp') !== 0) url = c.toDataURL('image/png');
        var daten = url.split(',')[1] || '';
        if (daten.length * 0.75 > 1024 * 1024) { zuruecksetzen(); ich.melden(MELDUNGEN.logo_gross); return; }
        ich.logo = daten;
        if (vorschau) { vorschau.src = url; vorschau.hidden = false; }
        if (leer) leer.hidden = true;
        if (name) name.textContent = datei.name;
        if (weg) weg.hidden = false;
      };
      bild.onerror = function () { URL.revokeObjectURL(adresse); zuruecksetzen(); ich.melden(MELDUNGEN.logo_typ); };
      bild.src = adresse;
    });
    if (weg) weg.addEventListener('click', zuruecksetzen);
  };

  /*
    Kurzanmeldung (Änderungsauftrag 1, 4.1): Firma + Postleitzahl an
    betrieb-vorschlag, bis zu fuenf Treffer zur Auswahl. Die Auswahl fuellt
    Strasse, Ort und Webseite vor und merkt sich nur die Google-Kennung.
  */
  InstallateurFormular.prototype.vorschlagEinrichten = function () {
    var ich = this;
    var knopf = this.form.querySelector('[data-inst-vorschlag]');
    var kasten = this.form.querySelector('[data-inst-vorschlaege]');
    if (!knopf || !kasten) return;
    var feld = function (n) { return ich.form.querySelector('[name="' + n + '"]'); };
    var hinweis = this.form.querySelector('[data-inst-google-hinweis]');
    // Im Ablauf: nach der Auswahl (oder ohne Treffer) weiter zu Schritt 2
    var danach = function (text) {
      if (!ich.schritte) return;
      if (hinweis) { hinweis.textContent = text || ''; hinweis.hidden = !text; }
      ich.zeige(ich.aktuell + 1);
    };
    // Neue Eingabe nach einer Suche: Vorschläge weg, "Weiter" sucht neu
    ['firma', 'plz'].forEach(function (n) {
      var f = feld(n);
      if (f) f.addEventListener('input', function () { if (!kasten.hidden) { kasten.hidden = true; feld('google_place_id').value = ''; } });
    });
    knopf.addEventListener('click', function () {
      if (ich.schritte && !ich.schrittGueltig()) return;
      var firma = (feld('firma').value || '').trim();
      var plz = (feld('plz').value || '').trim();
      if (firma.length < 2 || !/^[0-9]{5}$/.test(plz)) { ich.melden('Bitte zuerst Firma und Postleitzahl eingeben.'); return; }
      ich.melden('');
      knopf.disabled = true;
      kasten.hidden = false;
      kasten.innerHTML = '<p class="inst-vorschlaege__laedt">Suche bei Google …</p>';
      fetch(ich.url + '/functions/v1/betrieb-vorschlag', {
        method: 'POST',
        headers: { apikey: ich.schluessel, 'Content-Type': 'application/json' },
        body: JSON.stringify({ firma: firma, plz: plz })
      })
        .then(function (r) { return r.json(); })
        .then(function (j) {
          if (j.status === 'aus') { kasten.innerHTML = '<p class="inst-vorschlaege__laedt">Die Google-Suche ist gerade nicht verfügbar. Bitte füllt die Felder selbst aus.</p>'; danach('Bitte tragt eure Adresse selbst ein.'); return; }
          var liste = (j.vorschlaege || []).filter(function (v) { return !v.geschlossen; });
          if (!liste.length) { kasten.innerHTML = '<p class="inst-vorschlaege__laedt">Kein passender Eintrag gefunden. Bitte füllt die Felder selbst aus.</p>'; danach('Bei Google haben wir keinen passenden Eintrag gefunden. Bitte tragt eure Adresse selbst ein.'); return; }
          kasten.innerHTML = '<p class="inst-vorschlaege__titel">Ist das euer Betrieb?</p>' + liste.map(function (v, i) {
            return '<button type="button" class="inst-vorschlag" data-i="' + i + '"><strong>' + esc(v.name) + '</strong><span>' + esc(v.adresse) + '</span>' +
              (v.webseite ? '<small>' + esc(v.webseite) + '</small>' : '') + '</button>';
          }).join('') + '<button type="button" class="inst-vorschlag inst-vorschlag--keiner" data-i="-1">Nicht dabei, wir füllen selbst aus</button>';
          kasten.querySelectorAll('[data-i]').forEach(function (b) {
            b.addEventListener('click', function () {
              var v = liste[Number(b.getAttribute('data-i'))];
              if (v) {
                if (v.name) feld('firma').value = v.name;
                if (v.strasse) feld('strasse').value = v.strasse;
                if (v.plz) feld('plz').value = v.plz;
                if (v.ort) feld('ort').value = v.ort;
                if (v.webseite) feld('website').value = v.webseite;
                feld('google_place_id').value = v.id || '';
                kasten.innerHTML = '<p class="inst-vorschlaege__gewaehlt">Übernommen: ' + esc(v.name) + '. Bitte prüft die Felder unten.</p>';
                danach('Von Google übernommen: ' + v.name + '. Bitte prüft die Angaben.');
              } else {
                feld('google_place_id').value = '';
                kasten.hidden = true;
                danach('');
              }
            });
          });
        })
        .catch(function () { kasten.innerHTML = '<p class="inst-vorschlaege__laedt">Die Google-Suche hat nicht geklappt. Bitte füllt die Felder selbst aus.</p>'; danach('Bitte tragt eure Adresse selbst ein.'); })
        .then(function () { knopf.disabled = false; });
    });
  };

  /*
    Nachweise nach der Anmeldung (freiwillig, Michel 21.09.2026): je Datei eine
    signierte Upload-Adresse von anmeldung-nachweis, Datei direkt in den privaten
    Speicher, danach bestaetigen (Pruefung von Typ und Groesse auf dem Server).
    Berechtigt ueber die signierte Kundennummer aus dem Formular.
  */
  var ERLAUBT = ['application/pdf', 'image/jpeg', 'image/png', 'image/webp'];
  var NAMEN = { handwerksrolle: 'Handwerkskarte', meisterbrief: 'Meisterbrief', netzbetreiber: 'Nachweis des Netzbetreibers', gewerbeanmeldung: 'Gewerbeanmeldung', haftpflicht: 'Betriebshaftpflicht' };
  InstallateurFormular.prototype.nachweiseEinrichten = function () {
    var ich = this;
    var kasten = this.danke && this.danke.querySelector('[data-inst-nachweise-hochladen]');
    if (!kasten || kasten.dataset.instBereit) return;
    kasten.dataset.instBereit = '1';
    var knopf = kasten.querySelector('[data-inst-nachweise-senden]');
    var stand = kasten.querySelector('[data-inst-hochlade-stand]');
    var kunde = {};
    ['kunde_id', 'kunde_zeit', 'kunde_sig'].forEach(function (n) { var f = ich.form.querySelector('[name="' + n + '"]'); kunde[n] = f ? f.value : ''; });
    var rufe = function (body) {
      var k = {}; for (var x in kunde) k[x] = kunde[x]; for (var y in body) k[y] = body[y];
      return fetch(ich.url + '/functions/v1/anmeldung-nachweis', {
        method: 'POST', headers: { apikey: ich.schluessel, 'Content-Type': 'application/json' }, body: JSON.stringify(k)
      }).then(function (r) { return r.json().catch(function () { return { status: 'fehler' }; }); });
    };
    knopf.addEventListener('click', function () {
      var felder = [].slice.call(kasten.querySelectorAll('[data-inst-nachweis]')).filter(function (f) { return f.files && f.files[0]; });
      if (!felder.length) { stand.hidden = false; stand.innerHTML = '<li>Bitte mindestens eine Datei auswählen.</li>'; return; }
      knopf.disabled = true;
      stand.hidden = false;
      stand.innerHTML = felder.map(function (f) { return '<li data-art="' + f.getAttribute('data-inst-nachweis') + '">' + esc(NAMEN[f.getAttribute('data-inst-nachweis')]) + ': wird hochgeladen …</li>'; }).join('');
      felder.reduce(function (kette, f) {
        return kette.then(function () {
          var art = f.getAttribute('data-inst-nachweis');
          var zeile = stand.querySelector('[data-art="' + art + '"]');
          var datei = f.files[0];
          var name = NAMEN[art];
          if (ERLAUBT.indexOf(datei.type) === -1) { zeile.textContent = name + ': nur PDF, JPG, PNG oder WebP'; return; }
          if (datei.size > 10 * 1024 * 1024) { zeile.textContent = name + ': größer als 10 MB'; return; }
          var bisFeld = kasten.querySelector('[data-inst-nachweis-bis="' + art + '"]');
          return rufe({ aktion: 'upload', art: art, typ: datei.type })
            .then(function (a) {
              if (a.status !== 'ok') throw a;
              return fetch(a.url, { method: 'PUT', headers: { 'Content-Type': datei.type }, body: datei }).then(function (r) {
                if (!r.ok) throw { grund: 'upload' };
                return rufe({ aktion: 'fertig', pfad: a.pfad, gueltig_bis: bisFeld ? bisFeld.value : '' });
              });
            })
            .then(function (b) {
              if (b.status !== 'ok') throw b;
              zeile.textContent = name + ': hochgeladen, wir sichten ihn.';
              f.value = '';
            })
            .catch(function (e) {
              zeile.textContent = name + ': hat nicht geklappt' + (e && e.grund === 'typ' ? ' (Dateityp)' : e && e.grund === 'gross' ? ' (zu groß)' : '') + '. Bitte später im Partnerbereich hochladen.';
            });
        });
      }, Promise.resolve()).then(function () { knopf.disabled = false; });
    });
  };

  function esc(t) {
    return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  InstallateurFormular.prototype.melden = function (text) {
    if (!this.fehler) return;
    this.fehler.textContent = text || '';
    this.fehler.hidden = !text;
    if (text) this.fehler.scrollIntoView({ block: 'center', behavior: 'smooth' });
  };

  InstallateurFormular.prototype.abschicken = function () {
    var ich = this;
    if (!this.form.reportValidity()) return;
    if (!this.url || !this.schluessel) {
      this.melden('Das Formular ist gerade nicht erreichbar. Bitte schreib uns an info@solaroutlet.de.');
      return;
    }
    this.melden('');
    this.knopf.disabled = true;
    this.knopf.classList.add('loading');

    var koerper = daten(this.form);
    koerper.quelle = location.href;
    if (this.logo) koerper.logo = { daten: this.logo };

    fetch(this.url + '/functions/v1/' + this.funktion, {
      method: 'POST',
      headers: { apikey: this.schluessel, 'Content-Type': 'application/json' },
      body: JSON.stringify(koerper)
    })
      .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { return { ok: r.ok, daten: j }; }); })
      .then(function (antwort) {
        var st = antwort.daten && antwort.daten.status;
        if (st === 'gesendet' || st === 'eingereicht' || st === 'bekannt') {
          ich.fertig(antwort.daten);
          return;
        }
        ich.melden(MELDUNGEN[antwort.daten && antwort.daten.grund] || MELDUNGEN.server);
      })
      .catch(function () { ich.melden(MELDUNGEN.server); })
      .then(function () {
        ich.knopf.disabled = false;
        ich.knopf.classList.remove('loading');
      });
  };

  InstallateurFormular.prototype.fertig = function (daten) {
    if (this.dankeNummer && daten.nummer) this.dankeNummer.textContent = daten.nummer;
    if (this.dankeBetrieb) {
      this.dankeBetrieb.textContent = daten.betrieb
        ? 'Wir haben deine Anfrage an ' + daten.betrieb + ' weitergeleitet. Der Betrieb meldet sich direkt bei dir.'
        : 'In deiner Gegend haben wir noch keinen Partnerbetrieb. Wir suchen einen für dich und melden uns.';
    }
    if (this.funktion === 'betrieb-anmelden') this.nachweiseEinrichten();
    if (this.danke) {
      this.form.hidden = true;
      this.danke.hidden = false;
      this.danke.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }
    if (window.gtag) {
      try { window.gtag('event', this.funktion === 'anfrage-senden' ? 'installateur_anfrage' : 'installateur_anmeldung'); } catch (x) {}
    }
  };

  function start() {
    document.querySelectorAll('[data-inst-formular]').forEach(function (f) {
      if (!f.dataset.instBereit) { f.dataset.instBereit = '1'; new InstallateurFormular(f); }
    });
    // Postleitzahl und Betrieb aus der Adresse uebernehmen, damit der Weg von
    // der Suche ins Formular nichts verliert.
    var suchteil = new URLSearchParams(location.search);
    var plz = suchteil.get('plz');
    var betrieb = suchteil.get('betrieb');
    if (plz && /^[0-9]{5}$/.test(plz)) {
      document.querySelectorAll('[data-inst-formular] input[name="plz"]').forEach(function (f) { if (!f.value) f.value = plz; });
    }
    var leistung = suchteil.get('leistung');
    if (leistung) {
      document.querySelectorAll('[data-inst-leistung-vorwahl]').forEach(function (f) {
        if (!f.value && f.querySelector('option[value="' + leistung.replace(/[^a-z_]/g, '') + '"]')) f.value = leistung;
      });
      document.querySelectorAll('[data-inst-formular] input[name="gewerke"][value="' + leistung.replace(/[^a-z_]/g, '') + '"]').forEach(function (f) { f.checked = true; });
    }
    if (betrieb) {
      document.querySelectorAll('[data-inst-formular] input[name="betrieb_handle"]').forEach(function (f) { if (!f.value) f.value = betrieb; });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', start);
})();
